const locationConfig = (loc = {}, action) => {
  switch (action.type) {
    case "GET_LOC":
      return action.playload;
    default:
      return loc;
  }
};
export default locationConfig;
